import { render, staticRenderFns } from "./AdminSupportStaffPicker.vue?vue&type=template&id=3791a1f6&scoped=true"
import script from "./AdminSupportStaffPicker.vue?vue&type=script&lang=js"
export * from "./AdminSupportStaffPicker.vue?vue&type=script&lang=js"
import style0 from "./AdminSupportStaffPicker.vue?vue&type=style&index=0&id=3791a1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3791a1f6",
  null
  
)

export default component.exports